import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ProcessingStatusModelsComponent } from './component/processing-status-models/processing-status-models.component';
import { DictionaryFieldsModule, MasterDetailModule } from '@sdbn/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { ColorPickerModule } from '@sdbn/tmc-common';
import { ApplicationClientCommonModule } from '@sdbn/common';
import { DictionaryModule } from '@sdbn/common';
import { CommonTranslationModule } from '@sdbn/common';
import { MatFormFieldModule as MatFormFieldModule } from '@angular/material/form-field';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatInputModule as MatInputModule } from '@angular/material/input';
import { MatCheckboxModule as MatCheckboxModule } from '@angular/material/checkbox';

@NgModule({
  declarations: [
    ProcessingStatusModelsComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,

    DictionaryModule,
    CommonTranslationModule,
    ColorPickerModule,
    ApplicationClientCommonModule,
    MasterDetailModule,
    DictionaryFieldsModule,
    MatFormFieldModule,
    DragDropModule,
    MatInputModule,
    MatCheckboxModule
  ]
})
export class ProcessingStatusModelsModule { }

